/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import * as styles from './index.styles'
//image
import ic_warning from '../../../../../../images/ic_warning.svg'

const ERR_USER_EXISTED = 'username đã tồn tại trong hệ thống'
const ERR_USER_NOT_FOUND = 'Tài khoản không đúng hoặc không tồn tại.'


const RowListResult = ({ data, stateConfig, dispatchConfig }) => {

    useEffect(() => {
        if (data.IsExist || data.IsNotFound) return;
        const { lstUserSelect } = stateConfig
        dispatchConfig({ lstUserSelect: [...lstUserSelect, data] })
    }, []);

    return (
        <styles.Bound>

            <div className="name" title={data.Name}>{data.Name}</div>
            <div className="role" title={data.Role}>{data.Role}</div>
            <div className="branch" title={`${data.BranchCode} - ${data.Branch}`}>{`${data.BranchCode} - ${data.Branch}`}</div>
            <div className="icon-check">
                {
                    data.IsExist || data.IsNotFound ?
                        <img
                            title={
                                data.IsExist
                                    ? ERR_USER_EXISTED
                                    : ERR_USER_NOT_FOUND
                            }
                            src={ic_warning}
                            alt="error-match"
                        />
                        :
                        <>
                            <div></div>
                        </>
                }
            </div>
        </styles.Bound>
    )
}

export default RowListResult
